import { setup } from "web/entrypoints/common/setup";
import "./css-partners";
import components from "./react-partners";

setup(components);
